import { password, required, Validator } from '@/entities/validation';
import { PasswordResettingUser } from './model';

export const validate: Validator<PasswordResettingUser> = user => [
  ...required(user.password, 'password'),
  ...password(user.password, 'password'),
];
